const pillTokens = ({ colors }) => ({
  colors: {
    default: {
      positive: {
        bg: colors.positive.default,
        color: colors.white,
      },
      informative: {
        bg: colors.informative.default,
        color: colors.white,
      },
      warning: {
        bg: colors.warning.default,
        color: colors.white,
      },
      negative: {
        bg: colors.negative.default,
        color: colors.white,
      },
      brand: {
        bg: colors.shadesPrimary.darkest,
        color: colors.white,
      },
      promotional: {
        bg: colors.promotional.secondary.default,
        color: colors.promotional.primary.default,
      },
      neutral: {
        bg: colors.neutral['70'],
        color: colors.neutral['0'],
      },
    },
    soft: {
      positive: {
        bg: colors.positive.lightest,
        color: colors.positive.dark,
      },
      informative: {
        bg: colors.informative.lightest,
        color: colors.informative.dark,
      },
      warning: {
        bg: colors.warning.lightest,
        color: colors.warning.dark,
      },
      negative: {
        bg: colors.negative.lightest,
        color: colors.negative.dark,
      },
      neutral: {
        bg: colors.neutral['30'],
        color: colors.neutral['80'],
      },
      brand: {
        bg: colors.shadesPrimary.lightest,
        color: colors.shadesPrimary.darkest,
      },
      promotional: {
        bg: colors.promotional.secondary.default,
        color: colors.promotional.primary.default,
      },
    },
    ghost: {
      positive: {
        borderColor: colors.positive.light,
        color: colors.positive.default,
      },
      informative: {
        borderColor: colors.informative.light,
        color: colors.informative.default,
      },
      warning: {
        borderColor: colors.warning.light,
        color: colors.warning.default,
      },
      negative: {
        borderColor: colors.negative.light,
        color: colors.negative.default,
      },
      brand: {
        bg: colors.shadesPrimary.darkest,
        color: colors.shadesPrimary.darkest,
      },
      promotional: {
        bg: colors.promotional.secondary.default,
        color: colors.promotional.primary.default,
      },
      neutral: {
        borderColor: colors.neutral['30'],
        color: colors.neutral['80'],
      },
    },
  },
});

export default pillTokens;
